{#if failed}
  <div class="box">
    Your browser settings are preventing the Twitter timeline of {name} to be shown.
    Open their <a href="https://twitter.com/{handle}">timeline on Twitter</a>.
  </div>
{:else}
  <div class="box">
    Since the new ownership of Twitter, this timeline has not been working well.
    You can also try opening their <a href="https://twitter.com/{handle}">timeline on Twitter</a>.
  </div>
{/if}

<div bind:this={twitterElement} />

<script>
  export let name, handle;

  import { onMount } from "svelte";

  let twitterElement;

  let failed;

  let retries = 0;

  onMount(() => {
    retry();
  });

  function retry() {
      if (!tryCreateTimeline()) {
        retries++;
        if(retries == 2) {
          failed = true;
        }
        else {
          setTimeout(retry, 1000);
        }
      }
  }

  function tryCreateTimeline() {
    if (window && window.twttr && window.twttr.widgets) {
      window.twttr.widgets.createTimeline(
        {
          sourceType: "profile",
          screenName: handle,
        },
        twitterElement,
        {
          dnt: true,
          width: 350,
          showReplies: false,
        }
      );
      return true;
    } else {
      return false;
    }
  }
</script>
